import axios from '../lib/axios';
import { handleUnauthorizedError } from '../lib/heartBeat';

//support modal actions
export const SEND_SUPPORT_REQUEST_START = 'SEND_SUPPORT_REQUEST_START';
export const SEND_SUPPORT_REQUEST_SUCCESS = 'SEND_SUPPORT_REQUEST_SUCCESS';
export const SEND_SUPPORT_REQUEST_FAILURE = 'SEND_SUPPORT_REQUEST_FAILURE';
export const RESET_SUPPORT_REQUEST = 'RESET_SUPPORT_REQUEST';

/**
 * Send support request using z-email-service as external service.
 * Example of supportRequestPayload sent to the email service:
 {
    "email":"authorized-studente@example.com",
    "message":"sasa",
    "fileUploader":{
       "file":{
          "preview":"blob:http://localhost:8080/589f60d8-0e51-49a0-a226-7688ae03fcd8"
       }
    },
    "type":"Problema di contenuti",
    "attachBlob":"amFwcG8=",
    "attachName":"jappo.txt",
    "attachType":"text/plain"
 }
 * @param isLoggedIn
 * @param supportRequestPayload
 * @return {function(*)}
 */

export function sendSupportRequest(isLoggedIn, supportRequestPayload) {
    return async dispatch => {
        dispatch({ type: SEND_SUPPORT_REQUEST_START });
        const url = isLoggedIn ? '/email/support' : '/email/anonymousSupport';

        try {
            supportRequestPayload.application = 'CREA VERIFICHE';

            // If attachment is present, add attachBlob, attachName and attachType to JSON
            if (supportRequestPayload.fileUploader && supportRequestPayload.fileUploader.file) {
                const fileContent = await getFileContent(supportRequestPayload.fileUploader.file);
                supportRequestPayload.attachBlob = fileContent;
                supportRequestPayload.attachName = supportRequestPayload.fileUploader.file.name;
                supportRequestPayload.attachType = supportRequestPayload.fileUploader.file.type;
            }
            await axios.post(url, supportRequestPayload);
            dispatch({
                type: SEND_SUPPORT_REQUEST_SUCCESS,
                payload: supportRequestPayload
            });
        } catch (err) {
            handleUnauthorizedError(err, dispatch);
            dispatch({
                type: SEND_SUPPORT_REQUEST_FAILURE,
                payload: err,
                error: true
            });
        }
    };
}

/**
 * Take a file pointer, return a Promise which is:
 * - resolved with the base64 encoded content of the file, when the file is read succesfully
 * - rejected with an error when an error occurs while reading the file
 * @param file
 * @return {Promise}
 */
function getFileContent(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function(evt) {
            resolve(btoa(evt.target.result));
        };
        reader.onerror = function(err) {
            reject(err);
        };
        reader.readAsBinaryString(file);
    });
}

export function resetSupportRequest() {
    return {
        type: RESET_SUPPORT_REQUEST
    };
}
